// extracted by mini-css-extract-plugin
export default {"textP":"TextP_textP__ROfiT"};